import { Button } from '@vk-cloud-solutions/marketing-ui';

import { ButtonConsult } from '~containers/Buttons/ButtonConsult/ButtonConsult';
import { ButtonRendererProps } from '~containers/Buttons/ButtonRenderer/ButtonRenderer.types';
import { DatasetActionValues, DatasetKeys } from '~types/Dataset.types';

export function ButtonRenderer(props: ButtonRendererProps) {
  const { apiAction } = props;

  if ('href' in props && props.href) {
    return <Button {...props} />;
  }

  if (!apiAction) {
    return <Button {...props} />;
  }

  if (DatasetKeys.UiAction in apiAction) {
    const action = apiAction[DatasetKeys.UiAction];

    switch (action) {
      case DatasetActionValues.renderForm:
        return <ButtonConsult {...props} />;
      default:
        return <Button {...props} />;
    }
  }

  return <Button {...props} />;
}
